/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Apps32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.857 19.429c.631 0 1.143.512 1.143 1.142v2.286c0 .631-.512 1.143-1.143 1.143h-2.286c-.63 0-1.142-.512-1.142-1.143v-2.286c0-.63.512-1.142 1.142-1.142h2.286zm-5.714 0c.63 0 1.143.512 1.143 1.142v2.286c0 .631-.512 1.143-1.143 1.143h-2.286c-.63 0-1.143-.512-1.143-1.143v-2.286c0-.63.512-1.142 1.143-1.142h2.286zm-5.714 0c.63 0 1.142.512 1.142 1.142v2.286c0 .631-.512 1.143-1.142 1.143H9.143A1.143 1.143 0 018 22.857v-2.286c0-.63.512-1.142 1.143-1.142h2.286zm11.428-5.715c.631 0 1.143.512 1.143 1.143v2.286c0 .63-.512 1.143-1.143 1.143h-2.286c-.63 0-1.142-.512-1.142-1.143v-2.286c0-.63.512-1.143 1.142-1.143h2.286zm-5.714 0c.63 0 1.143.512 1.143 1.143v2.286c0 .63-.512 1.143-1.143 1.143h-2.286c-.63 0-1.143-.512-1.143-1.143v-2.286c0-.63.512-1.143 1.143-1.143h2.286zm-5.714 0c.63 0 1.142.512 1.142 1.143v2.286c0 .63-.512 1.143-1.142 1.143H9.143A1.143 1.143 0 018 17.143v-2.286c0-.63.512-1.143 1.143-1.143h2.286zM22.857 8C23.488 8 24 8.512 24 9.143v2.286c0 .63-.512 1.142-1.143 1.142h-2.286c-.63 0-1.142-.512-1.142-1.142V9.143c0-.631.512-1.143 1.142-1.143h2.286zm-5.714 0c.63 0 1.143.512 1.143 1.143v2.286c0 .63-.512 1.142-1.143 1.142h-2.286c-.63 0-1.143-.512-1.143-1.142V9.143c0-.631.512-1.143 1.143-1.143h2.286zm-5.714 0c.63 0 1.142.512 1.142 1.143v2.286c0 .63-.512 1.142-1.142 1.142H9.143A1.142 1.142 0 018 11.43V9.143C8 8.512 8.512 8 9.143 8h2.286z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default Apps32;
